<template>
  <v-data-table-virtual
    :headers="headers"
    :items="accountsData"
    fixed-header
    height="150"
    density="compact"
  >
    <template v-slot:item="{ item }">
      <tr class="hover-row" @click="handleRowClick(item)">
        <td class="">{{ item.accountId }}</td>
        <td class="">{{ item.house }}</td>
        <td class=" align-end">{{ item.amount }}</td>
      </tr>
    </template>

    <template v-slot:header="{ column }">
      <span class="page-text-title">{{ column.text }}</span>
    </template>

  </v-data-table-virtual>
</template>
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useCallWindowStore } from '@/stores/callWindow'

const router = useRouter()
const callWindowStore = useCallWindowStore()
const handleRowClick = (account) => {
  // console.log('account: ', JSON.stringify(account, null, 2))
  // ToDo: get client details from backend
  router.push({ name: 'clientDetails', params: { accountId: account.id } })
  callWindowStore.minimizeWindow()
}
// ToDo: Mock data to be received via props
const accountsData = ref([
  {
    accountId: 'А98237498234324',
    house: 'пр. Дружбы Народов 123, 34',
    amount: 3521.34,
  },
  {
    accountId: 'М11232134134',
    house: 'ул. Пушкина 72, 234',
    amount: 0.00,
  },
  {
    accountId: 'А98237498234324',
    house: 'пр. Дружбы Народов 133, 12',
    amount: -1500.00,
  },
  {
    accountId: 'М11232134134',
    house: 'ул. Пушкина 12, 21',
    amount: 4500.00,
  },
])

const headers = ref([
  {
    title: 'ЛС',
    key: 'accountId',
    align: 'start',
  },
  {
    title: 'Адрес',
    key: 'house',
    align: 'start',
  },
  {
    title: 'Долг',
    key: 'amount',
    align: 'end',
  },
])
</script>

<style lang="scss" scoped>

.page-text-title {
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
}

.align-end {
  text-align: end;
}

.hover-row {
  transition: background-color 0.3s ease;

  &:hover {
    background-color: rgb(var(--v-theme-brandLight));
    cursor: pointer;
  }
}

</style>
